@if (hasAttributes) {
  @for (group of attributes | keyvalue; track group.key) {
    <h3 [ngClass]="titleClass">{{ group.key }}</h3>
    @for (attr of group.value; track $index) {
      <div class=" mb-3">
        <div class="d-flex align-items-center justify-content-start m-0">
          <div class="attribute-icon">
            <img [src]="attr.icon" [alt]="attr.name">
          </div>
          <div class="attribute-description ml-2 bg-transparent p-2 d-block w-100">
            <div class="text-uppercase font-weight-bold mb-1">{{ attr.name }}</div>
            <div class="">{{ attr.description }}</div>
          </div>
        </div>
      </div>
    }
  }
}
